import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = [ 'template', 'items' ]

  add(event) {
    const NEW_RECORD_ID = /([\[_])0([_\]])/g
    const content = this.templateTarget.innerHTML.replaceAll(NEW_RECORD_ID, `$1${this.itemsTargets.length + 1}$2`)

    event.target.closest('button').insertAdjacentHTML('afterend', content)
  }

  remove(event) {
    const item = event.target.closest("[data-nested-form-target='items']");
    const destroyField = item.querySelector("input[name*='_destroy']");

    if (destroyField) {
      destroyField.value = 1;
      item.style.display = 'none';
      // required fields inside a hidden-for-removal item still block native form
      // submission via the browser's constraint validation, even though they won't be
      // persisted (they're skipped server-side via reject_if/_destroy); dropping
      // `required` here lets the form submit normally.
      item.querySelectorAll('[required]').forEach((field) => field.required = false);
    } else {
      item.remove();
    }
  }
}
